/**
 * Dashboard 翻译 - 英文
 * Dashboard Translations - English
 */
import { DashboardTranslations } from './zh';

export const dashboardEn: DashboardTranslations = {
  // Page titles
  title: 'Dashboard',
  subtitle: 'Welcome Back',
  greeting: 'Hello, {name}!',
  welcome: 'Welcome to FF AI Workspace System',
  
  // Stats cards
  stats: {
    title: 'Overview',
    total: 'Total',
    pending: 'Pending',
    inProgress: 'In Progress',
    completed: 'Completed',
    thisMonth: 'This Month',
    thisWeek: 'This Week',
    today: 'Today',
    increase: 'Increase',
    decrease: 'Decrease',
    
    // Specific metrics
    totalApprovals: 'Pending Approvals',
    totalTasks: 'Pending Tasks',
    totalNotifications: 'Unread Notifications',
    totalWorkRecords: 'Work Records',
  },
  
  // Quick actions
  quickActions: {
    title: 'Quick Actions',
    createApproval: 'Create Approval', // Keep old key for compatibility
    createRequest: 'New Request',      // New key
    createWorkRecord: 'Submit Work Record',
    viewApprovals: 'View Approvals',
    viewTasks: 'View Tasks',
    viewNotifications: 'View Notifications',
    createExpense: 'Create Expense',
    submitLeave: 'Submit Leave',
    viewOrganization: 'Organization',
  },
  
  // Recent activity
  recentActivity: {
    title: 'Recent Activity',
    noActivity: 'No recent activity',
    loadMore: 'Load More',
    viewAll: 'View All',
    
    // Activity types
    approvalCreated: 'created an approval',
    approvalApproved: 'approved an approval',
    approvalRejected: 'rejected an approval',
    workRecordSubmitted: 'submitted a work record',
    taskCompleted: 'completed a task',
  },
  
  // Todos
  todos: {
    title: 'To-Do List',
    noTodos: 'No to-do items',
    add: 'Add To-Do',
    complete: 'Complete',
    delete: 'Delete',
    markComplete: 'Mark as Complete',
    markIncomplete: 'Mark as Incomplete',
  },
  
  // Notifications
  notifications: {
    title: 'Notifications',
    noNotifications: 'No notifications',
    markAllRead: 'Mark All as Read',
    viewAll: 'View All Notifications',
  },
  
  // Date time
  time: {
    morning: 'Good Morning',
    afternoon: 'Good Afternoon',
    evening: 'Good Evening',
    lastUpdated: 'Last Updated',
    refreshData: 'Refresh Data',
  },
};

